function ErrorPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="card">
          <div className="text-6xl mb-4">❌</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Une erreur est survenue
          </h1>
          <p className="text-gray-600 mb-6">
            Nous n'avons pas pu traiter votre signature.
            Le lien peut avoir expiré ou être invalide.
          </p>
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <p className="text-sm text-red-800">
              Veuillez contacter l'émetteur du document pour obtenir un nouveau lien.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
